// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';
import { BridgeServiceRequest } from '@daml.js/utility-bridge-app-v0/lib/Utility/Bridge/App/V0/Service/Bridge';

const useBridgeServiceRequest: () => UseQueryResult<
  TemplateContract<BridgeServiceRequest>,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  const { bridgeOperator } = useParties();
  return useQuery({
    queryKey: ['queryBridgeServiceRequest', bridgeOperator, offset, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryBridgeServiceRequest(offset!, bridgeOperator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useBridgeServiceRequest;
